import React, { useEffect, useRef } from 'react';
import { useTranslation, Trans } from 'react-i18next'; // Добавьте Trans
import styled from 'styled-components';
import { Container } from '../styles/styled';
import Image from '../images/whatwedo.png';

const WhatWeDoWrapper = styled.section`
  padding: 40px 0 80px 0;

  .content-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 40px;

    @media (max-width: 1024px) {
      gap: 30px;
    }

    @media (max-width: 768px) {
      flex-direction: column;
      text-align: center;
    }
  }

  .text-content {
    flex: 1;

    .btn {
      padding: 10px;
      text-align: center;
      width: 150px;
      display: block;
      color: #002dff;
      font-weight: 700;
      border: 1px solid #002dff;
      border-radius: 10px;
      text-decoration: none;
      font-size: 18px;
      margin-top: 30px;
      margin-left: 0;
      margin-right: auto;

      @media (max-width: 768px) {
        margin: 20px auto 0;
      }

      opacity: 0;
      transform: translateY(20px);
      transition: opacity 0.6s ease-out, transform 0.6s ease-out, background-color 0.3s ease;
      
      &:hover {
        background-color: #29f0b4;
      }
    }

    .badge {
      opacity: 0;
      transform: translateX(-20px);
      transition: opacity 0.6s ease-out, transform 0.6s ease-out;

      @media (max-width: 768px) {
        margin: 0 auto -20px;
      }
    }

    h2 {
      text-align: left;
      font-size: 36px;
      color: #002dff;
      margin-bottom: 20px;

      @media (max-width: 1024px) {
        font-size: 30px;
      }

      @media (max-width: 768px) {
        font-size: 26px;
      }

      opacity: 0;
      transform: translateY(20px);
      transition: opacity 0.6s ease-out, transform 0.6s ease-out;
    }

    p {
      font-size: 18px;
      color: #555;
      line-height: 1.6;
      opacity: 0;
      transform: translateY(20px);
      transition: opacity 0.6s ease-out, transform 0.6s ease-out;
      margin-bottom: 20px;

      @media (max-width: 1024px) {
        font-size: 17px;
      }

      @media (max-width: 768px) {
        font-size: 16px;
      }
    }

    .simple-terms {
      font-style: italic;
      color: #777;
      font-size: 16px;

      @media (max-width: 768px) {
        font-size: 15px;
      }
    }
  }

  .image-content {
    flex: 1;
    display: flex;
    justify-content: center;

    img {
      max-width: 100%;
      height: auto;
      border-radius: 10px;
      opacity: 0;
      transform: translateX(30px) scale(0.95);
      transition: opacity 0.8s ease-out, transform 0.8s ease-out;

      @media (max-width: 768px) {
        max-width: 90%;
        margin-top: 20px;
        transform: translateY(20px) scale(0.95);
      }
    }
  }

  /* Анимации при появлении */
  &.visible {
    .badge {
      opacity: 1;
      transform: translateX(0);
      transition-delay: 0.1s;
    }

    h2 {
      opacity: 1;
      transform: translateY(0);
      transition-delay: 0.2s;
    }

    p {
      opacity: 1;
      transform: translateY(0);
      transition-delay: 0.4s;
    }

    .simple-terms {
      opacity: 1;
      transform: translateY(0);
      transition-delay: 0.5s;
    }

    .btn {
      opacity: 1;
      transform: translateY(0);
      transition-delay: 0.6s;
    }

    .image-content img {
      opacity: 1;
      transform: translateX(0) scale(1);
      transition-delay: 0.3s;
    }
  }
`;

const WhatWeDo = () => {
  const { t } = useTranslation('common');
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
   <WhatWeDoWrapper id="what-we-do" ref={sectionRef}>
      <Container>
        <div className="content-wrapper">
          <div className="text-content">
            <span
              className="badge"
              style={{
                backgroundColor: '#78ffd6',
                height: 'fit-content',
                borderRadius: '8px',
                display: 'block',
                width: '140px',
                color: '#78ffd6',
                fontSize: '37px',
                marginBottom: '-45px',
                marginLeft: '-10px',
              }}
            >
              S
            </span>
            <h2>{t('whatWeDo.title')}</h2>
            <p>
              <Trans
                i18nKey="whatWeDo.description1"
                shouldUnescape={true}
                components={{ selected: <span className="text-selected" />, br: <br /> }}
                defaults="Fallback text if key not found" // Добавьте fallback для теста
              />
            </p>
            <p>
              {t('whatWeDo.description2')}
            </p>
            <p className="simple-terms">
              <Trans
                i18nKey="whatWeDo.simpleTerms"
                shouldUnescape={true}
                components={{ br: <br /> }}
                defaults="Fallback simple terms if key not found" // Fallback для теста
              />
            </p>
            {/* <a className="btn" href="#contact">
              {t('whatWeDo.learnMore')}
            </a> */}
          </div>
          <div className="image-content">
            <img src={Image} alt={t('whatWeDo.imageAlt')} />
          </div>
        </div>
      </Container>
    </WhatWeDoWrapper>
  );
};

export default WhatWeDo;